module.exports = __webpack_public_path__ + "img/eastcool-gray.aa18f1e.png";